export const LOAN_PIPELINE_FILTER_LABEL_ALL = "All Pipelines";
